/**
 * @file ContactsSections.tsx
 * @description «Настройки сайта → Контакты» и «→ Соцсети» (phase19.16 Р1;
 * SB18, SB21, SB58, SB85; uiux-design-r1 §4). Оба раздела правят один
 * список `brand.contacts`; строки держатся в окне, а на сервер уходит
 * только список, где все значения проходят проверку реестра (иначе
 * ошибочная соцсеть не дала бы сохранить остальное) — `useContactRows`.
 */

import { TextField } from "../TextField";
import { ContactsList } from "./ContactsList";
import { useCurrentContext } from "../../../auth/hooks";
import type { PartFieldsApi } from "../../../hooks/site-view/usePartFields";
import type { ContactRowsApi } from "../../../hooks/site-view/useContactRows";
import { PLAIN_KINDS, SOCIAL_KINDS } from "../../../lib/site-view/contacts-edit";
import type { SiteBrandDraft } from "../../../lib/site-view/types";

type RowsApi = ContactRowsApi;

interface Props {
  brand: PartFieldsApi<SiteBrandDraft>;
  contacts: RowsApi;
}

export function ContactsSection({ brand, contacts }: Props) {
  const slug = useCurrentContext()?.shop?.slug ?? "";
  const { rows, update } = contacts;
  return (
    <div className="flex flex-col gap-4">
      <ContactsList
        rows={rows.plain}
        kinds={PLAIN_KINDS}
        social={false}
        total={rows.plain.length + rows.social.length}
        shopEmail={brand.fields.shopContactEmail}
        shopSettingsHref={`/shop/${slug}/settings/shop`}
        onChange={(plain) => update({ ...rows, plain })}
      />
      <TextField
        label="Часы работы (необязательно)"
        value={brand.fields.workingHours ?? ""}
        max={120}
        placeholder="Пн–Пт 10:00–19:00"
        hint="Покажем в подвале и передадим поисковикам."
        onChange={(v) => brand.set("workingHours", v)}
      />
    </div>
  );
}

export function SocialsSection({ brand, contacts }: Props) {
  const slug = useCurrentContext()?.shop?.slug ?? "";
  const { rows, update } = contacts;
  return (
    <ContactsList
      rows={rows.social}
      kinds={SOCIAL_KINDS}
      social
      total={rows.plain.length + rows.social.length}
      shopEmail={brand.fields.shopContactEmail}
      shopSettingsHref={`/shop/${slug}/settings/shop`}
      onChange={(social) => update({ ...rows, social })}
    />
  );
}
